var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlimMom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-SlimMom",
    viewBox: "0 0 212 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    style: {
      fill: "var(--color1, #212121)"
    },
    d: "M0 27.163l1.457-1.69c1.718 1.577 3.415 2.725 5.090 3.443 1.676 0.704 3.605 1.056 5.787 1.056 2.253 0 4.091-0.57 5.513-1.711s2.133-2.605 2.133-4.393c0-1.127-0.232-2.063-0.697-2.809-0.451-0.746-1.31-1.422-2.577-2.028-1.253-0.605-3.013-1.141-5.281-1.605-3.647-0.746-6.266-1.781-7.857-3.105-1.577-1.338-2.366-3.168-2.366-5.492 0-2.267 0.922-4.161 2.767-5.682s4.168-2.281 6.97-2.281c2.14 0 4.006 0.296 5.597 0.887 1.591 0.577 3.182 1.507 4.774 2.788l-1.415 1.774c-1.394-1.211-2.823-2.084-4.288-2.619-1.45-0.535-3.035-0.803-4.752-0.803-2.197 0-3.978 0.556-5.344 1.669-1.366 1.098-2.049 2.478-2.049 4.14 0 1.141 0.225 2.091 0.676 2.851 0.465 0.746 1.345 1.443 2.64 2.091 1.31 0.634 3.14 1.19 5.492 1.669 3.506 0.718 6.041 1.739 7.604 3.063 1.577 1.324 2.366 3.112 2.366 5.365 0 2.422-0.943 4.408-2.83 5.956-1.887 1.535-4.295 2.302-7.224 2.302-2.38 0-4.548-0.394-6.506-1.183-1.943-0.789-3.837-2.007-5.682-3.654z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    style: {
      fill: "var(--color1, #212121)"
    },
    d: "M32.905 31.578v-31.578h2.112v31.578h-2.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    style: {
      fill: "var(--color1, #212121)"
    },
    d: "M46.884 3.76v-2.894h2.619v2.894h-2.619zM47.138 31.578v-22.052h2.112v22.052h-2.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    style: {
      fill: "var(--color1, #212121)"
    },
    d: "M61.054 31.578v-22.052h2.133v3.929c0.408-0.648 0.817-1.211 1.225-1.69s0.901-0.936 1.478-1.373c0.591-0.451 1.274-0.796 2.049-1.035 0.789-0.239 1.655-0.359 2.598-0.359 1.802 0 3.323 0.444 4.562 1.331 1.253 0.873 2.211 2.014 2.873 3.422 1.845-3.168 4.499-4.752 7.963-4.752 2.605 0 4.668 0.838 6.189 2.514s2.281 3.908 2.281 6.696v13.37h-2.112v-13.117c0-2.366-0.577-4.21-1.732-5.534s-2.753-1.985-4.795-1.985c-1.943 0-3.591 0.704-4.943 2.112s-2.028 3.302-2.028 5.682v12.842h-2.112v-13.244c0-2.281-0.584-4.084-1.753-5.407-1.155-1.324-2.718-1.985-4.689-1.985s-3.64 0.767-5.006 2.302c-1.366 1.521-2.049 3.394-2.049 5.618v12.716h-2.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc842d",
    style: {
      fill: "var(--color2, #fc842d)"
    },
    d: "M105.589 30.407v-30.289h2.112l12.166 17.912 12.145-17.912h2.133v30.289h-2.26v-26.297l-11.976 17.426h-0.169l-11.997-17.426v26.297h-2.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc842d",
    style: {
      fill: "var(--color2, #fc842d)"
    },
    d: "M144.62 19.382c0-1.535 0.289-3.006 0.866-4.415s1.359-2.633 2.345-3.675c0.986-1.056 2.19-1.894 3.612-2.514 1.422-0.634 2.936-0.95 4.541-0.95 2.126 0 4.056 0.528 5.788 1.584 1.746 1.042 3.098 2.45 4.055 4.224 0.972 1.76 1.457 3.675 1.457 5.745 0 2.056-0.486 3.964-1.457 5.724s-2.338 3.175-4.098 4.246c-1.746 1.056-3.689 1.584-5.83 1.584-1.591 0-3.091-0.31-4.499-0.929s-2.605-1.45-3.591-2.492c-0.986-1.042-1.767-2.267-2.345-3.675-0.563-1.422-0.845-2.908-0.845-4.457zM146.901 19.382c0 2.661 0.873 4.921 2.619 6.78 1.76 1.845 3.915 2.767 6.463 2.767 1.605 0 3.098-0.423 4.478-1.267 1.38-0.859 2.478-2.021 3.295-3.485s1.225-3.063 1.225-4.795c0-2.647-0.887-4.9-2.661-6.759-1.774-1.873-3.915-2.809-6.421-2.809-1.633 0-3.14 0.429-4.52 1.288-1.38 0.845-2.471 2.007-3.274 3.485-0.803 1.464-1.204 3.063-1.204 4.795z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc842d",
    style: {
      fill: "var(--color2, #fc842d)"
    },
    d: "M177.25 30.407v-22.051h2.133v3.929c0.408-0.648 0.817-1.211 1.225-1.69s0.901-0.936 1.479-1.373c0.591-0.451 1.274-0.796 2.049-1.035 0.789-0.239 1.655-0.359 2.598-0.359 1.802 0 3.323 0.444 4.562 1.331 1.253 0.873 2.211 2.014 2.873 3.422 1.845-3.168 4.499-4.752 7.963-4.752 2.604 0 4.668 0.838 6.188 2.514 1.522 1.676 2.282 3.908 2.282 6.696v13.37h-2.112v-13.117c0-2.366-0.578-4.21-1.732-5.534-1.156-1.324-2.754-1.985-4.796-1.985-1.942 0-3.59 0.704-4.942 2.112s-2.028 3.302-2.028 5.682v12.842h-2.112v-13.243c0-2.281-0.584-4.084-1.753-5.407-1.155-1.324-2.718-1.985-4.689-1.985s-3.64 0.767-5.006 2.302c-1.366 1.521-2.049 3.394-2.049 5.618v12.715h-2.133z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlimMom);
export default __webpack_public_path__ + "static/media/slim-mom.ecb807efe9d75308f4aec16b41824a97.svg";
export { ForwardRef as ReactComponent };